import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    AutoRelatedSliderContainer as AdvoxAutoRelatedSliderContainer,
    mapDispatchToProps,
} from 'AdvoxComponent/AutoRelatedSlider/AutoRelatedSlider.container';
import AutoRelatedQuery from 'Query/AutoRelated.query';
import { getIndexedProduct } from 'Util/Product';
import { fetchQuery } from 'Util/Request';

import AutoRelatedSlider from './AutoRelatedSlider.component';

/** @namespace Pwa/Component/AutoRelatedSlider/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    productUrlSuffix: state.ConfigReducer.product_url_suffix,
});

/** @namespace Pwa/Component/AutoRelatedSlider/Container */
export class AutoRelatedSliderContainer extends AdvoxAutoRelatedSliderContainer {
    static propTypes = {
        ...this.propTypes,
        uid: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
    };

    state = {
        sliderItems: [],
        isLoading: false,
        title: '',
    };

    componentDidMount() {
        this.requestProductRelated();
    }

    performDataTransformations(data) {
        return data.map(({ image, ...rest }) => ({
            ...getIndexedProduct(rest),
            small_image: image,
        }));
    }

    async requestProductRelated() {
        const { uid, position } = this.props;
        await fetchQuery(AutoRelatedQuery.getProductPageAutoRelated(uid, position))
            .then(
                /** @namespace Pwa/Component/AutoRelatedSlider/Container/AutoRelatedSliderContainer/requestProductRelated/then/catch/fetchQuery/then */
                ({ amMostviewedGroups: { items } }) => {
                    this.setState({
                        sliderItems: this.performDataTransformations(items[0].items),
                        title: items[0].block_title,
                    });
                }
            )
            .catch(
                /** @namespace Pwa/Component/AutoRelatedSlider/Container/AutoRelatedSliderContainer/requestProductRelated/then/catch */
                () => this.setState({ isLoading: false })
            );
    }

    containerProps() {
        const { sliderItems, isLoading, title } = this.state;
        return {
            sliderItems,
            isLoading,
            title,
        };
    }

    render() {
        return <AutoRelatedSlider {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoRelatedSliderContainer);
